import * as Yup from "yup";

const itemAddSchema = Yup.object().shape({});

export default itemAddSchema;
